import http from '@/http/httpFormData.js';
import QS from 'qs'

// hr 相关的接口

export default {

    /**
     * 外出打卡
     */
    tripBillApply: params => http.post(`/joa-business/tripBillApply`, QS.stringify(params)),


}